import PersonApi from '../../../api/person/PersonApi';
import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/banking-operations',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'banking-operations-filter-fulltext',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: 'type',
      getItems: async () => [{ value: 'inbound', label: 'Przychód' }, { value: 'outbound', label: 'Rozchód' }],
      reset: async () => null,
      placeholder: 'Przychód/Rozchód:',
      badge: 'Status:',
      testName: 'banking-operations-filter-type',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_bank_account_original_multi',
      getItems: async () => {
        const boss = await PersonApi.getBoss();

        const { data } = await PersonApi.getBankAccountsWithOpenBankLinks({
          'personOriginal': boss?.data?.original,
        });

        return Object.values(data)
          .map((item) => {
            return {
              value: item.original,
              label: item.label,
            };
          });
      },
      reset: async () => null,
      placeholder: 'Nazwa banku',
      badge: 'Nazwa banku:',
      testName: 'banking-operations-filter-bank-account-multi',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: '_settlement_status_multi',
      getItems: async () => [
        { value: 'settled', label: 'Rozliczono' },
        { value: 'pending', label: 'Nie rozliczono' },
        { value: 'partially_settled', label: 'Częściowo' },
        { value: 'manually_settled', label: 'Ręcznie rozliczono' },
        { value: 'pending_to_manual_match', label: 'Brak dopasowania' },
      ],
      reset: async () => null,
      placeholder: 'Status rozliczenia',
      badge: 'Status rozliczenia:',
      testName: 'banking_operations_filter_settlement_status_multi',
      inputType: FiltersType.MULTI_SELECT_TYPE,//multi?
    },
    {
      key: 'operation_date',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Zakres dat operacji',
      testName: 'banking-operations-filter-date-range',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
  ],
};
